import { useUsageStore } from '../stores/usageStore.js';
import { enCreditos } from './creditos.js';

/** ¿La UI habla en créditos? (bandera CREDITOS_ENABLED del API, vía /usage.unidad.activo). */
export function useEnCreditos(): boolean {
  return useUsageStore((s) => enCreditos(s.data));
}
